export const GET_PENALTIES = Symbol('GET_PENALTIES');
export const GET_PENALTIES_REQUEST = Symbol('GET_PENALTIES_REQUEST');
export const GET_PENALTIES_SUCCESS = Symbol('GET_PENALTIES_SUCCESS');
export const GET_PENALTIES_ERROR = Symbol('GET_PENALTIES_ERROR');

